'use strict';

bbw.directive.bbwChatScroll = ['$rootScope', function($rootScope) {
    var autoScrollLoopLimit = 10;
    return {
        restrict: 'A',
        scope: {
            'conversation': '=bbwChatScroll',
            'eventName': '=scrollDownOn'
        },
        link: function(scope, element) {
            var el = element[0];
            var isScrolledUp = false;
            var isAutoScroll = false;
            var isLoading = false;

            function scrollTo(pos) {
                if (el.scrollTo) {
                    el.scrollTo(0, pos);
                } else {
                    el.scrollTop = pos;
                }
            }

            element.on('scroll', function() {
                if (isAutoScroll) {
                    return;
                }
                isScrolledUp = el.scrollTop + el.offsetHeight < el.scrollHeight;
                if (!isLoading && el.scrollTop < 1 && scope.conversation && scope.conversation.hasOlderMessages()) {
                    isLoading = true;
                    var origHeight = el.scrollHeight;
                    scope.conversation.loadMoreFromHistory().finally(function() {
                        isLoading = false;
                        setTimeout(function() {
                            var newHeight = el.scrollHeight;
                            if (newHeight > origHeight) {
                                scrollTo(newHeight - origHeight);
                            }
                        }, 0);
                    });
                }
            });

            var scrollDown = function scrollDown(autoScrollLoopLimit, force) {
                if (isScrolledUp && !force) {
                    isAutoScroll = false;
                    return;
                }
                isAutoScroll = true;
                scrollTo(el.scrollHeight);
                setTimeout(function() {
                    if (autoScrollLoopLimit > 0 && el.scrollTop + el.offsetHeight < el.scrollHeight) {
                        scrollDown(autoScrollLoopLimit - 1, force);
                    } else {
                        isAutoScroll = false;
                        isScrolledUp = false;
                    }
                }, 150);
            };

            $rootScope.$on(scope.eventName, function(event, args) {
                scrollDown(autoScrollLoopLimit, angular.isObject(args) && args.force);
            });

            window.addEventListener('scroll', scrollDown);
            scope.$on('$destroy', function() {
                window.removeEventListener('scroll', scrollDown);
            });
        }
    };
}];
